import React, { useState } from 'react';
import { useFormik } from 'formik';
import { TRACKING_CLICKS, UserManagementService } from 'api';
import { useClickTracking } from 'hooks';
import { resetPasswordSchema } from './validationSchema';
import { ResetPasswordFormView } from './ResetPasswordFormView';

export interface ResetPasswordStateProps {
  isSent: boolean;
  errorMessage: '';
}

export const ResetPasswordForm = (): React.ReactElement => {
  const [state, setState] = useState<ResetPasswordStateProps>({ isSent: false, errorMessage: '' });
  const track = useClickTracking(TRACKING_CLICKS.RESET_PASSWORD);
  const {
    errors,
    values: { email },
    isSubmitting,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: resetPasswordSchema,
    onSubmit: ({ email }, { setSubmitting }) => {
      UserManagementService.resetPassword(email)
        .then(() => {
          track();
          setState({ isSent: true, errorMessage: '' });
        })
        .catch(r => setState({ isSent: false, errorMessage: typeof r === 'string' ? r : r?.message }))
        .finally(() => setSubmitting(false));
    },
  });

  return (
    <ResetPasswordFormView
      email={email}
      isSubmitting={isSubmitting}
      state={state}
      errors={errors}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
};
